<template>
  <div
    v-if="booking"
    class="booking-details table"
  >
    <div class="table-cell">
      <img
        class="inner-logo"
        src="/assets/logo-light.svg"
        alt="Spabreaks.com"
        width="300"
      >

      <div
        v-if="noNights() > 0"
        class="pill"
      >
        Overnight Reservation
      </div>
      <h2>{{ customerName }}</h2>
      <p
        v-if="arrivalDate()"
        v-html="arrivalDetails"
      />
      <p v-html="customerDetails" />
      <p
        v-if="booking.has_reservation_form_pdf"
        :class="['download-link', { 'is-downloading': isDownloading }]"
        @click="downloadPdf"
      >
        <i class="far fa-download fa:after" aria-hidden="true"></i>
        <span>Download PDF of original confirmation</span>
      </p>
    </div>
    <div class="table-cell-right download-print">
      <button
        class="button print-button"
        @click="printPage"
      >
        <i class="far fa-print fa:after" aria-hidden="true"></i>
        Print latest copy
      </button>
    </div>
  </div>
</template>

<script>
import { date } from 'lib/date-and-time-formats'
import { inflect } from 'inflection'
import markdownit from 'markdown-it'
const markdown = markdownit({ html: true })

export default {
  name: 'SbBookingDetails',

  props: {
    booking: {
      type: Object,
      required: true,

      reference: {
        type: String,
        required: true
      },

      customer_name: {
        type: String,
        required: true
      },

      sales_agent: {
        type: String,
        default: null
      }
    },

    itineraryItems: {
      type: Array,
      required: true
    },

    isYgtBooking: {
      type: Boolean,
      default: false
    },

    fetchReservationFormPdf: {
      type: Function,
      required: true
    }
  },

  mounted() {
    const script = document.createElement('script');
    script.src = "https://kit.fontawesome.com/852742862b.js";
    script.crossOrigin = "anonymous";
    script.async = true;
    document.head.appendChild(script);
  },

  data () {
    return {
      isDownloading: false
    }
  },

  computed: {
    customerName () {
      return this.booking.customer_name
    },

    customerDetails () {
      const phone_number = this.booking.customer ? this.phoneText(this.booking.customer.phone) : null
      const email = this.booking.customer ? this.emailText(this.booking.customer.email) : null

      return markdown.render([phone_number, email].filter(x => !!x).join(' / '))
    },

    arrivalDetails () {
      return markdown.render(
        `Arrives: **${this.arrivalDate()}** (${this.nightsText()})`
      )
    }
  },

  methods: {
    phoneText (phone_number) {
      if (!phone_number) return ''
      return 'Tel: **' + phone_number + '**'
    },

    emailText (email) {
      if (!email) return ''

      return 'Email: **' + email + '**'
    },

    nightsText () {
      const noNights = this.noNights()

      if (noNights > 0) {
        return `${noNights} ${inflect('night', noNights)}`
      }

      return 'Day spa'
    },

    noNights () {
      const itemsWithNights = this.itineraryItems.filter((ii) => ii.nights !== undefined)

      if (itemsWithNights.length > 0) {
        return itemsWithNights[0].nights
      } else {
        return 0
      }
    },

    arrivalDate () {
      const spaItem = this.itineraryItems.filter((ii) => ii.type === 'spa')[0]
      if (spaItem !== undefined) {
        return date(spaItem.booking_travel_date)
      }

      const hotelItem = this.itineraryItems.filter((ii) => ii.type === 'hotel')[0]
      if (hotelItem !== undefined) {
        return date(hotelItem.check_in_date)
      }
      return null
    },

    printPage () {
      window.print()
    },

    downloadPdf () {
      if (this.isDownloading) {
        return
      }

      this.isDownloading = true
      this.fetchReservationFormPdf(this.booking.reference, this)
    }
  }
}
</script>
